<template>
    <section class="fac-card-toggle" :class="[status ? 'active' : '', setShadow]">
        <div class="title" :class="{ 'slim': slim }" @click="toggle($event)">
            <div class="box-title">
                <div v-if="icon" class="ico">
                    <i :class="icon" />
                </div>
                <div class="text">
                    <!-- @slot Define o título do card -->
                    <slot name="title" />
                </div>
            </div>
            <div v-if="status" class="filter">
                <!-- @slot Espaço normalmente utilizado para colocar um select para criar filtros para o conteúdo -->
                <slot name="filter" />
            </div>
            <div class="icon-toggle">
                <i class="fas" :class="status ? 'fal fa-chevron-up' : 'fal fa-chevron-down'" />
            </div>
        </div>
        <div class="content" :class="[maxHeight ? 'overflow-y' : '', design]" :style="heightCss">
            <div v-if="isMark" class="content-mark">
                <slot name="mark" />
            </div>
            <!-- @slot Espaço para conteúdo do card -->
            <div class="content-body">
                <div v-if="loading" class="loader-units-block">
                    <ui-load-indicator :h="50" :stroke="8" bg-color="#DFE5EC" color="#69D296" />
                </div>

                <slot v-else name="content" />
            </div>
        </div>
    </section>
</template>

<script>
	import { uiLoadIndicator } from '@/components/ui'

	/**
	* Componente para um card que possibilita abrir e fechar o seu conteúdo
	* @displayName ui-card-toggle
	*/
	export default {
		name: 'ui-card-toggle',

		components: { uiLoadIndicator },

		props: {
			/**
			* Define se o card iniciará aberto ou fechado
			*/
			open: {
				type: Boolean,
				required: false,
				default: false,
			},
			/**
			* Define um ícone ao lado do título
			*/
			icon: {
				type: String,
				required: false,
				default: ''
			},
			/**
			* Define a altura máxima do card. Ao definir uma altura máxima, caso o conteúdo seja grande será gerado uma barra de rolagem
			*/
			maxHeight: {
				type: Number,
				required: false,
				default: null
			},
			/**
			* Permite criar um efeito de sobra valores de 1 a 3
			*/
			shadow: {
				type: Number,
				required: false,
				default: null
			},
			/**
			* Aplica classes adicionais ao componente
			*/
			design: {
				type: String,
				required: false,
				default: ''
			},
			isMark: {
				type: Boolean,
				default: false
			},
			setStatus: {
				type: Boolean,
				default: false
			},
			/**
			 * Define se será mostrado o loading para o card
			 */
			loading: {
				type: Boolean,
				required: false,
				default: false
			},
			slim: {
				type: Boolean,
				required: false,
				default: false
			}
		},

		data() {
			return {
				status: false,
				heightCss: {
					height: this.maxHeight + 'px',
				},
			}
		},

		computed: {
			setShadow: function () {
				return 'shadow-' + this.shadow
			},
		},

		created(){
			this.statusDefault()
		},

		mounted() {
			this.status = this.setStatus
		},

		methods: {
			toggle(event) {
				if(event.target.closest('.filter')) return

				this.status = !this.status
				this.$emit('toggle', this.status)
			},
			statusDefault() {
				this.status = this.open ? true : false
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl';
</style>

